import React from 'react'
import { Tooltip } from 'antd'
import { EditTwoTone, PlusOutlined, DeleteTwoTone } from '@ant-design/icons'
import styled from 'styled-components'
import cloneDeep from 'lodash/cloneDeep'
import { ReactSortable } from 'react-sortablejs'

const Container = styled.div`
    margin-top: 10px;
    padding: 5px 10px;
    border-radius: 2px;
    background-color: #f6f6f6;
    .drop-area {
        padding: 0px 15px 0px 30px;
        &-level2 {
            background-color: #f6f6f6;
        }
    }
    .sortable-chosen {
        background-color: lightblue;
    }
    .sortable-drag {
        background-color: lightblue;
    }
    .block-item-level2 {
        margin-top: 0px !important;
    }
`

const StyledBlockWrapper = styled.div`
    cursor: grab;
    position: relative;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    border: 1px solid #e8e8e8;
    background: #fff;
`

const ItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    .icon {
        padding-right: 10px;
    }
    .topic {
        flex: 1;
        display: flex;
        padding: 15px;
        .title {
            font-weight: bold;
        }
        .tag {
            padding-left: 10px;
        }
        .type {
            color: #aaa;
            padding-left: 10px;
            text-transform: capitalize;
        }
    }
    .action {
        cursor: pointer;
        display: flex;
        padding: 15px;
        > .item {
            padding-left: 10px;
            &:hover {
                color: #1890ff;
            }
        }
    }
`

const sortableOptions = {
    animation: 150,
    fallbackOnBody: true,
    swapThreshold: 0.6,
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    emptyInsertThreshold: 30,
    forceFallback: true,
    scrollSensitivity: 100,
    group: {
        name: 'nested',
        pull: function (to, from, el) {
            let toLevel = to.options.dataIdAttr || 1
            if (toLevel > 3) {
                return false
            } else {
                let maxLevel = 1
                if (el.innerHTML.search('data-level="3"') !== -1) {
                    maxLevel = 3
                } else if (el.innerHTML.search('data-level="2"') !== -1) {
                    maxLevel = 2
                }
                if (toLevel - 1 + maxLevel > 3) {
                    return false
                }
            }
            return true
        }
    }
}

const DragBoard = ({
    T,
    menuList,
    setBlocks,
    setState,
    onEditMenu,
    onRemoveMenu,
    onAddSubmenu
}) => {
    return (
        <Container>
            <ReactSortable
                dataIdAttr={1}
                list={menuList}
                setList={setBlocks.bind(this)}
                {...sortableOptions}>
                {menuList.map((block, blockIndex) => (
                    <BlockWrapper
                        key={block.id}
                        T={T}
                        block={block}
                        level={1}
                        blockIndex={[blockIndex]}
                        setBlocks={setState.bind(this)}
                        onEditMenu={onEditMenu.bind(this)}
                        onRemoveMenu={onRemoveMenu.bind(this)}
                        onAddSubmenu={onAddSubmenu.bind(this)}
                    />
                ))}
            </ReactSortable>
        </Container>
    )
}

function ContainerฺBlock({
    T,
    block,
    blockIndex,
    level,
    setBlocks,
    onEditMenu,
    onRemoveMenu,
    onAddSubmenu
}) {
    block.submenus = block.submenus || []
    return (
        <>
            <ReactSortable
                key={block.id}
                dataIdAttr={level}
                list={block.submenus}
                setList={currentList => {
                    setBlocks(prevState => {
                        const tempList = cloneDeep(prevState.menuList)
                        const _blockIndex = [...blockIndex]
                        const lastIndex = _blockIndex.pop()
                        const lastArr = _blockIndex.reduce(
                            (arr, i) => arr[i]['submenus'] || [],
                            tempList
                        )
                        lastArr[lastIndex]['submenus'] = currentList
                        return { menuList: tempList }
                    })
                }}
                {...sortableOptions}>
                {block.submenus &&
                    block.submenus.map((childBlock, index) => {
                        return (
                            <BlockWrapper
                                key={childBlock.id}
                                T={T}
                                block={childBlock}
                                level={level}
                                blockIndex={[...blockIndex, index]}
                                setBlocks={setBlocks.bind(this)}
                                onEditMenu={onEditMenu.bind(this)}
                                onRemoveMenu={onRemoveMenu.bind(this)}
                                onAddSubmenu={onAddSubmenu.bind(this)}
                            />
                        )
                    })}
            </ReactSortable>
        </>
    )
}
function BlockWrapper({
    T,
    block,
    blockIndex,
    level,
    setBlocks,
    onEditMenu,
    onRemoveMenu,
    onAddSubmenu
}) {
    if (!block) return null

    return (
        <StyledBlockWrapper
            data-level={level}
            className={`block ${level % 2 == 0 ? 'block-item-level2' : ''}`}>
            <ItemContainer>
                <div className="topic">
                    {block.icon && (
                        <div className="icon">
                            <i className={`icon-${block.icon}`} />
                        </div>
                    )}
                    <div className="title">{block.title}</div>
                    {block.tag_title && block.tag_title != '' && (
                        <div className="tag">
                            <div
                                className={`menutypetag menutypetag--${block.tag_color} animated infinite ${block.tag_effect}`}>
                                {block.tag_title}
                            </div>
                        </div>
                    )}
                </div>
                <div className="action">
                    <div
                        className="item"
                        onClick={() => onEditMenu(blockIndex, block)}>
                        <Tooltip placement="top" title={T('EDIT')}>
                            <EditTwoTone />
                        </Tooltip>
                    </div>
                    <div
                        className="item"
                        onClick={() => onRemoveMenu(blockIndex)}>
                        <Tooltip placement="top" title={T('REMOVE')}>
                            <DeleteTwoTone twoToneColor="#ff4d4f" />
                        </Tooltip>
                    </div>
                    {level <= 2 && (
                        <div
                            className="item"
                            onClick={() => onAddSubmenu(blockIndex)}>
                            <Tooltip placement="top" title={T('ADD_SUBMENU')}>
                                <PlusOutlined />
                            </Tooltip>
                        </div>
                    )}
                </div>
            </ItemContainer>
            {level < 3 && (
                <div
                    className={`clearfix drop-area ${
                        level % 2 == 0 ? 'drop-area-level2' : ''
                    }`}>
                    <ContainerฺBlock
                        T={T}
                        block={block}
                        level={level + 1}
                        blockIndex={blockIndex}
                        setBlocks={setBlocks.bind(this)}
                        onEditMenu={onEditMenu.bind(this)}
                        onRemoveMenu={onRemoveMenu.bind(this)}
                        onAddSubmenu={onAddSubmenu.bind(this)}
                    />
                </div>
            )}
        </StyledBlockWrapper>
    )
}

export default DragBoard
